import { makeStyles } from 'tss-react/mui'
import { theme } from '../../../theme'

export const useStyles = makeStyles()(() => ({
  shell: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    maxHeight: '100vh',
    overflow: 'hidden',
    padding: theme.spacing(3, 3, 2.5),
    fontFamily: theme.typography.fontFamily,
    background: theme.palette.bgPrimary.main,
  },
  scrollableBody: {
    flex: '1 1 auto',
    minHeight: 0,
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  footer: {
    flexShrink: 0,
    paddingTop: theme.spacing(3.5),
  },
  referralList: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: theme.spacing(2),
    gap: theme.spacing(2.25),
  },
  referralRow: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    maxWidth: '100%',
    cursor: 'pointer',
    userSelect: 'none',
  },
  referralCheckbox: {
    flex: '0 0 auto',
    margin: 0,
    width: 'auto',
    '& .MuiFormControlLabel-label': {
      margin: 0,
    },
  },
  referralLabel: {
    fontSize: '16px',
    lineHeight: '16px',
  },
  externalLink: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    flexShrink: 0,
    width: 'auto',
    fontSize: '14px',
    lineHeight: '20px',
  },
  externalLinkIcon: {
    marginLeft: 0,
  },
  externalLinkHiddenLabel: {
    position: 'absolute',
    width: theme.spacing(0.125),
    height: theme.spacing(0.125),
    padding: 0,
    margin: theme.spacing(-0.125),
    overflow: 'hidden',
    // clip: 'rect(0, 0, 0, 0)',
    border: 0,
  },
  emptyState: {
    margin: 0,
    fontSize: '14px',
    lineHeight: 1.5,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: theme.spacing(1.5),
  },
  applyBtn: {
    marginLeft: theme.spacing(2),
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(1.25, 2.25),
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: 1,
    minWidth: theme.spacing(11),
    textTransform: 'none',
    color: theme.palette.bgPrimary.main,
  },
  cancelBtn: {
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(1.25, 2.25),
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: 1,
    minWidth: theme.spacing(11),
    textTransform: 'none',
  },
  feedback: {
    flexShrink: 0,
    marginTop: theme.spacing(1.5),
    fontSize: '13px',
    borderRadius: '4px',
    padding: theme.spacing(1, 1.25),
  },
  feedbackError: {
    color: theme.palette.error.main,
    background: theme.palette.error.light,
    border: `1px solid ${theme.palette.error.main}`,
  },
  feedbackSuccess: {
    color: theme.palette.success.main,
    background: theme.palette.success.light,
    border: `1px solid ${theme.palette.success.main}`,
  },
}))
